import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import React from "react";
import { Control, FieldValues, RegisterOptions } from "react-hook-form";

import { Path } from "react-hook-form";

interface FormInputProps<T extends FieldValues = FieldValues> {
  name: Path<T>;
  control: Control<T>;
  label?: string;
  placeholder?: string;
  rules?: RegisterOptions<T, Path<T>>;
  type?: string;
  className?: string;
  inputClassName?: string;
  autoComplete?: string;
  icon?: React.ReactNode;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  maxLength?: number;
  characterLimit?: number;
}

export const FormInput = <T extends FieldValues = FieldValues>({
  name,
  control,
  label,
  placeholder,
  rules,
  type = "text",
  className,
  inputClassName,
  autoComplete,
  icon,
  inputProps,
  maxLength,
  characterLimit,
}: FormInputProps<T>) => (
  <FormField
    control={control}
    name={name}
    rules={rules}
    render={({ field, fieldState }) => (
      <FormItem className={className}>
        {label && <FormLabel>{label}</FormLabel>}
        <div className="relative">
          {icon && (
            <span className="top-1/2 left-3 absolute -translate-y-1/2">
              {icon}
            </span>
          )}
          <FormControl>
            <Input
              {...field}
              value={field.value ?? ""}
              type={type}
              placeholder={placeholder}
              autoComplete={autoComplete}
              className={cn(icon ? "pl-10" : "", inputClassName)}
              maxLength={maxLength}
              onChange={(event) => {
                if (type === "number") {
                  const nextValue = event.target.value;
                  field.onChange(nextValue === "" ? "" : Number(nextValue));
                  return;
                }

                field.onChange(event);
              }}
              {...inputProps}
            />
          </FormControl>
        </div>
        {characterLimit !== undefined ? (
          <div
            className={`text-right text-xs ${
              String(field.value ?? "").length > characterLimit
                ? "text-destructive"
                : "text-muted-foreground"
            }`}
          >
            {String(field.value ?? "").length} / {characterLimit}
          </div>
        ) : null}
        <FormMessage>{fieldState.error?.message}</FormMessage>
      </FormItem>
    )}
  />
);
